import styled from "styled-components";
import {PC_HORIZONTAL_SPACE_BETWEEN_ITEMS} from "../../../../../../../../basic-components/space-between-items-consts";

export const GamePlayPcHeaderBarTopSectionBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 60px;
  width: 100%;
  padding-left: ${PC_HORIZONTAL_SPACE_BETWEEN_ITEMS(2)};
  padding-right: ${PC_HORIZONTAL_SPACE_BETWEEN_ITEMS()};
`